import Jed from 'jed';
import locales from '../../locales';

const locale = localStorage.getItem('c19aLocale') || 'pl';
const initialState = {
    translator: new Jed(locales[locale]),
    locale: locale
};

const languageReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_LANGUAGE':
            return {
                locale: action.locale,
                translator: new Jed(locales[action.locale] || locales['pl'])
            };
        default:
            return state;
    }
};

export default languageReducer;
